import * as React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import "./Login.scss";
import { useMediaQuery, useTheme } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import lightlogo from "../../Img/light-mode-logo.png";
import { toast, ToastContainer } from 'react-toastify';
import { useLocation } from "react-router-dom";
import AuthLeft from "./AuthLeft";
import AuthHeader from "./AuthHeader";
import successgif from "../../Img/success2.gif"
import Loader from "../Loader";

export default function Success() {


    const theme = useTheme();
    const md = useMediaQuery(theme.breakpoints.up('md'));
    const lg = useMediaQuery(theme.breakpoints.up('lg'));

    const navigate = useNavigate();
    const location = useLocation()



    return (
        <>
           {/* <AuthHeader/> */}
           
              <ToastContainer />
              <Loader/>
          <div className='register'>
                <Grid container component="main" sx={{ alignItems:"center", height:!lg && "100vh" }} className={!md ? 'medium' : ''}>

              {lg &&  <Grid item xs={12} sm={12} md={6} lg={5.5}>
            <AuthLeft/>
          </Grid>}
          <Grid item xs={12} sm={12} md={6} lg={6.5}>
                        <Grid container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Box
                                    sx={{
                                        my: md && 3,
                                        mx: md && 8,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        // padding: '28px 25px',
                                        justifyContent:"center",
                                        margin:"0 auto" ,
                                        padding:"10px"
                                    }}
                                >

                                    {/* <Typography component="h1" variant="h2" className="text-center login-left-title" sx={{ mt: 1, mb: 3 ,fontSize:'25px'}}>
                                    Success
                                    </Typography> */}
                               
                               <div className="success-gif">
                               <img src={successgif} alt="success" />
                               </div>
                               <div className="email-fill">
                      <div className="email-name sucess-text" style={{ marginTop: "8px" }}>
                        <p>Your Email has been verified successfully</p>
                      </div>
                      </div>
                      <div className="common-btn">
                      <Button
                          type="submit"
                          fullWidth
                          variant="contained"
                          sx={{ mt: 6, mb: 2 }}
                          onClick={() => navigate("/login")}
                        >
                         Continue
                        </Button>
                        </div>


                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}
